import React from "react";
import { ReactSVG } from "react-svg";
import styles from "./why_attend.module.scss";

const data = [
  {
    id: 1,
    title: "Profile Evaluation",
    description:
      "Get an on-spot profile assessment from university representatives to discover study abroad opportunities",
  },
  {
    id: 2,
    title: "Program Shortlisting",
    description:
      "Explore personalized program offerings matching your study preferences and student profile",
  },
  {
    id: 3,
    title: "Admissions Requirements",
    description:
      "Thoroughly understand intakes, deadlines, application steps and requirements for your desired programs",
  },
  {
    id: 4,
    title: "Begin Applications",
    description:
      "Access support from university representatives and UniSearch Student Success Consultants to begin your applications right away",
  },
  {
    id: 5,
    title: "And More",
    description:
      "Learn about visa requirements, scholarship availability, student work experience opportunities, and more, directly from US university representatives",
  },
];

export const EventWhyAttent = ({ goToBookNow, goToviewLocation, ...props }) => {
  return (
    <section className={styles.section_why_attend}>
      <div className={styles.overlay}></div>
      <div className={`container ${styles.container}`}>
        <div className={styles.attent_container}>
          <div>
            <h1 className={styles.attent_heading}>
              Why Attend <br /> USA Admission Day?
            </h1>
            <div className={styles.des_wrapper}>
              <p>
                Learn more about higher education opportunities at one of the
                world’s best destinations for studying abroad, directly from
                attending universities!
              </p>
              <div className={styles.left_border}></div>
            </div>
            <div className={styles.button_container}>
              <button
                type="button"
                onClick={goToviewLocation}
                className="btn btn-white btn-md"
              >
                View Location
              </button>
              <button
                type="button"
                onClick={goToBookNow}
                className="btn btn-secondary btn-md"
              >
                Book Now
              </button>
            </div>
          </div>
          <div className={styles.right}>
            {data?.map((item, i) => {
              return (
                <div key={i}>
                  <div className={styles.wrapper}>
                    <ReactSVG src="/assets/icons/list-icon.svg" />
                    <h4 className={styles.sub_heading}>{item?.title}</h4>
                  </div>
                  <div
                    className={styles.description}
                    style={{ border: data.length - 1 === i ? "0" : null }}
                  >
                    <p>{item?.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventWhyAttent;
